import { useEffect, useState } from 'react';
import { MAC_DOWNLOAD_URL, MAC_DOWNLOAD_RELEASE, MAC_DOWNLOAD_OVERRIDE } from '@/constants/macDownload';
import { MAC_DOWNLOAD_MANIFEST_URL, parseMacDownloadManifest } from '@/lib/macDownloadManifest.cjs';

export default function useMacDownloadRelease() {
  const [download, setDownload] = useState({ url: MAC_DOWNLOAD_URL, release: MAC_DOWNLOAD_RELEASE, local: false });
  useEffect(() => {
    if (MAC_DOWNLOAD_OVERRIDE) return undefined;
    const local = __DEV__ && ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
    const controller = new AbortController();
    let active = true;
    const refresh = async () => {
      try {
        const response = await fetch(local ? '/macos/local-download.json' : MAC_DOWNLOAD_MANIFEST_URL,
          { cache: 'no-store', signal: controller.signal });
        if (!response.ok) return;
        const release = parseMacDownloadManifest(await response.json(), { local });
        if (active && release) setDownload(previous => {
          // Public releases only advance. Local builds may share a build number
          // while being iterated; their content-addressed filename changes.
          if (!local && previous.release?.build > release.build) return previous;
          return { url: release.url, release, local };
        });
      } catch (_) { /* Keep the verified build-time fallback if offline. */ }
    };
    refresh();
    window.addEventListener('focus', refresh);
    return () => { active = false; controller.abort(); window.removeEventListener('focus', refresh); };
  }, []);
  return download;
}
